<template>
  <div class="sidebar" style="max-height:80vh; overflow-y: scroll">
    <v-card :class="$vuetify.breakpoint.mdAndUp ? 'rounded-un shaddow-un' : 'pb-6 rounded-un shaddow-un'">
      <div class="px-6 pt-6">
        <TheUserHeader />
      </div>
      <div class="mx-5 inner-menu" v-if="$vuetify.breakpoint.mdAndUp"></div>
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <div class="px-6 mb-1">
          <div v-for="(item, i) in menu" :key="i" class="mb-1">
            <v-btn class="rounded-pill home-buttom color-purple font-dm" @click="check(item.route)" depressed :text="checkRoute(item.route)">
              <img :src="require(`@/assets/${item.icon}`)" width="16px" class="mr-5" />
              {{ item.text }}
            </v-btn>
          </div>
        </div>
        <div :class="open ? 'opened px-5 mt-1 py-2' : 'px-5 my-1 py-2'">
          <v-row align="center" justify="center" @click="open = !open">
            <v-col cols="8">
              <div class="home-buttom color-purple font-dm" style="padding: 0 16px">
                <v-icon class="mr-3" color="#502d7c">{{ conf.icon }} </v-icon>
                {{ conf.text }}
              </div>
            </v-col>
            <v-col class="text-right">
              <v-icon color="#502d7c" v-if="open">mdi-chevron-up</v-icon>
              <v-icon color="#502d7c" v-if="!open">mdi-chevron-down</v-icon>
            </v-col>
          </v-row>
        </div>

        <v-slide-y-transition>
          <v-card color="#F8F8F8" flat style="border-radius: 0 0 15px 15px">
            <div v-if="open" class="px-6 pb-5">
              <div class="mb-1">
                <v-btn class="rounded-pill home-buttom color-purple font-dm" to="/perfil" depressed text>
                  <img :src="require(`@/assets/Group-purple.png`)" height="20px" class="mr-5" />
                  Meu Perfil
                </v-btn>
              </div>

              <div v-for="(item, i) in conf.menu" :key="i" class="mb-1">
                <v-btn class="rounded-pill home-buttom color-purple font-dm" :to="item.route" depressed text>
                  <img :src="require(`@/assets/${item.icon}`)" width="16px" class="mr-5" />
                  {{ item.text }}
                </v-btn>
              </div>

              <div class="mb-1">
                <v-btn class="rounded-pill home-buttom color-purple font-dm" @click="openTutorial()" depressed text>
                  <img :src="require(`@/assets/alert-circle-purple.png`)" height="20px" class="mr-5" />
                  Tutorial Interativo
                </v-btn>
              </div>

              <div class="mb-1">
                <v-btn class="rounded-pill home-buttom color-purple font-dm" to="/page/regras" depressed text>
                  <img src="@/assets/book-purple.png" width="16px" class="mr-5" />
                  Regras e Regulamento
                </v-btn>
              </div>

              <v-btn class="rounded-pill home-buttom color-purple font-dm" @click="preventLogoff()" depressed text> <v-icon class="mr-3">mdi-logout</v-icon> Sair </v-btn>
            </div>
          </v-card>
        </v-slide-y-transition>
      </div>
    </v-card>
  </div>
</template>

<script>
import TheUserHeader from '@/components/TheUserHeader'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['option']),
  },
  data: () => ({
    route: null,
    open: false,
    menu: [
      { text: 'Home', icon: 'home-purple.png', route: '/' },
      { text: 'Ideias', icon: 'idea-purple.png', route: '/ideias' },
      { text: 'Ações', icon: 'zap-purple.png', route: '/acoes' },
      { text: 'Jornada', icon: 'map-purple.png', route: '/jornada' },
      { text: 'Salvos', icon: 'bookmark.png', route: '/salvos' },
    ],
    conf: {
      text: 'Configurações',
      icon: 'mdi-cog-outline',
      menu: [
        {
          text: 'Sobre Nós',
          icon: 'book-open-purple.png',
          route: '/page/sobre',
        },
      ],
    },
    prevent: false,
  }),
  components: {
    TheUserHeader,
  },
  methods: {
    appendIcon(children) {
      if (!children) {
        return ''
      }

      if (children.length > 0) {
        return 'mdi-chevron-down'
      } else {
        return ''
      }
    },
    preventLogoff() {
      this.prevent = true
      this.$store.dispatch('setLogoffInfo', true)
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'Tem certeza que deseja sair?',
        button: [{ text: 'Sair' }, { text: 'Não', outlined: true }],
      })
    },
    logoff() {
      localStorage.removeItem('user')
      window.location = '//www.unisinos.br/conecta'
    },
    openTutorial() {
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'Vamos reativar as dicas que vão lhe apresentar algumas funcionalidades da nossa plataforma.',
        button: 'Beleza, reativar!',
      })
      this.$store.dispatch('setResetInfo', true)
    },
    check(el) {
      this.route = el
      const profile = localStorage.getItem('salveProfile')
      if (profile) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Deseja salvar as alterações?',
          button: [{ text: 'Salvar' }, { text: 'Cancelar', outlined: true }],
        })
      } else {
        this.$router.push(el)
      }
    },
    checkRoute(item) {
      if (item === this.$route.path) {
        return false
      } else {
        return true
      }
    },
  },
  watch: {
    option() {
      const profile = localStorage.getItem('salveProfile')
      if (!this.prevent) {
        if (profile && this.option === 1) {
          this.$router.push(this.route)
          localStorage.removeItem('salveProfile')
          this.$store.dispatch('setOptionInfo', null)
        }
      }

      if (this.prevent) {
        if (this.option === 0) {
          this.logoff()
          this.prevent = false
        }
        if (this.option === 1) {
          this.prevent = false
        }
        this.$store.dispatch('setLogoffInfo', true)
      }
    },
  },
}
</script>

<style>
.inner-menu {
  border-top: 1px solid #eeeeee;
  margin-top: 32px;
  padding-top: 20px;
}

.home-buttom {
  /* opacity: 0.1; */
  /* border-radius: 100px; */
  /* background-color: #edeaf1 !important; */
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 0;
  line-height: 21px;
}

.opened {
  background: #edeaf1;
}

.sidebar {
  position: -webkit-sticky !important; /* Safari */
  position: sticky !important;
  top: 132px;
}

.button-configuracoes {
  background: none !important;
}
</style>
